import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const TwitchIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#fff"
      d="M5.63 1 2.5 4.21V15.8h3.75V19l3.13-3.21h2.5L17.5 10V1zm10.62 8.36-2.5 2.57h-2.5l-2.19 2.25v-2.25H6.25V2.29h10z"
    />
    <path fill="#fff" d="M14.38 4.54h-1.26v3.85h1.26zM10.94 4.54H9.69v3.85h1.25z" />
  </svg>
);
